import { customerColor, customerInitials } from '../lib/customerColor';

type Props = {
  readonly name: string | null | undefined;
};

export function CustomerMark({ name }: Props) {
  const safeName = name?.trim() || 'Ohne Kunde';
  const color = customerColor(safeName);
  const lightInk = color === '#bef03c' || color === '#cbf363';
  return (
    <div className="customer">
      <div
        className="cust-mark"
        style={{ background: color, color: lightInk ? '#00343a' : '#fff' }}
      >
        {customerInitials(safeName)}
      </div>
      <div style={{ minWidth: 0, overflow: 'hidden' }}>
        <div className="name">{safeName}</div>
      </div>
    </div>
  );
}
